<template>
    <v-card shaped :class="`rounded-card mx-auto mt-5 item ${$route.path.includes('car') && 'car'}`" max-width="344" height="300px" @click="showItem">
        <div class="text-center">
            <img :src="item.img" />
        </div>
        <div class="d-flex">
            <v-card-title>{{ item.name }}</v-card-title>
            <div class="price">
                <p>${{ formatAmount(item.price) }}</p>
            </div>
        </div>
        <v-card-actions class="flex justify-space-around actions">
            <v-btn icon v-if="!isInCart">
                <v-icon @click.native="addToCart" color="#fff">mdi-cart-plus</v-icon>
            </v-btn>
            <v-btn icon v-else>
                <v-icon @click.native="removeItem" color="#fff">mdi-cart-minus</v-icon>
            </v-btn>
            <div class="line"></div>
            <v-btn icon>
                <v-icon @click="showItem" color="#fff">mdi-eye</v-icon>
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
    props: getProps(),
    data: () => ({
        quantity: 1,
    }),
    computed: {
        isInCart() {
            return !!this.$store.state.shoppingList.filter(key => key.id === this.item.id && key.brand === this.item.brand).length;
        },
    },
    methods: {
        showItem() {
            this.$emit('view-item', this.item);
        },
        removeItem() {
            this.$store.commit('removeFromCart', this.item);
            this.$swal({
                type: 'success',
                text: 'Item has been removed from the cart',
            });
        },
    }
}

function getProps() {
    return {
        item: {
            type: Object,
            required: true,
        }
    }
}
</script>

<style>
.item {
    cursor: pointer;
    max-height: 350px;
}

.item .v-card__title {
    font-size: 1rem;
}

.d-flex .price {
    position: absolute;
    top: 15px;
    right: 15px;
    color: #3F51B5;
}

.item img {
    height: 200px;
    margin-top: 20px;
}

.car img {
    height: 200px;
    margin-top: 40px;
    width: 250px;
}

.item .actions {
    position: absolute;
    bottom: 0px;
    background-color: #EBEBEB;
    background-color: #3F51B5;
    width: 100%;
    display: none;
}

.item:hover .actions {
    /* display: flex; */
    transition: display 2s ease;
}

.line {
    border-right: 1px solid #fff;
    height: 35px;
}
</style>